import { APIController } from '../../api/controller';
import { AccountOrdersPageModel } from './model';
import { action, runInAction } from 'mobx';
import { RouterState, RedirectFunction } from 'react-router';
import {UserModel} from "../../user/model";
import { EnvModel } from '../../env/model';
import { UIController } from '../../ui/controller';
import {stripQueryString} from '../../../lib/string';

export class AccountOrdersPageController {
  constructor(
    private user: UserModel,
    private model: AccountOrdersPageModel,
    private api: APIController,
    private env: EnvModel,
    private ui: UIController
  ) {}

  @action
  onEnter = async (nextState: RouterState, replace: RedirectFunction) => {
    const page = parseInt(stripQueryString(nextState.params['page'])) || 1;

    try {
      runInAction(() => {
        this.model.loadingMore = true;
        this.ui.setBreadcrumbs([{
          path: '/account',
          label: 'Account'
        }, {
          path: '/account/orders',
          label: 'Orders'
        }]);
      });

      await this.ui.setSEO(nextState.location.pathname);

      const [orders] = await Promise.all([
        this.api.user.getOrders(this.user.user.identity, page),
        this.env.ready
      ]);

      runInAction(() => {
        this.model.orders = orders.data;
        this.model.pagination = orders.meta.pagination;
        this.model.loadingMore = false;
      });

      return;
    } catch (e) {
      replace({
        pathname: `/account/licenses`
      });
    }

    return;
  };
}
